var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachMoney({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3005_13850",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3005_13850)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.625 41.7998V37.6498C20.7417 37.3331 19.1917 36.6248 17.975 35.5248C16.7583 34.4248 15.8917 33.0415 15.375 31.3748L18.05 30.2498C18.6167 31.8498 19.4333 33.0331 20.5 33.7998C21.5667 34.5665 22.8417 34.9498 24.325 34.9498C25.9417 34.9498 27.2667 34.5456 28.3 33.7373C29.3333 32.929 29.85 31.8331 29.85 30.4498C29.85 28.9831 29.3917 27.8373 28.475 27.0123C27.5583 26.1873 25.825 25.3665 23.275 24.5498C20.925 23.8165 19.1667 22.8373 18 21.6123C16.8333 20.3873 16.25 18.8165 16.25 16.8998C16.25 15.0831 16.8375 13.5665 18.0125 12.3498C19.1875 11.1331 20.725 10.4415 22.625 10.2748V6.1748H25.5V10.2748C27.0167 10.4415 28.3042 10.9373 29.3625 11.7623C30.4208 12.5873 31.225 13.5915 31.775 14.7748L29.1 15.9248C28.6333 14.9081 28 14.154 27.2 13.6623C26.4 13.1706 25.3667 12.9248 24.1 12.9248C22.5833 12.9248 21.375 13.2706 20.475 13.9623C19.575 14.654 19.125 15.6165 19.125 16.8498C19.125 18.0831 19.5958 19.0956 20.5375 19.8873C21.4792 20.679 23.275 21.4748 25.925 22.2748C28.225 22.9915 29.9333 23.9873 31.05 25.2623C32.1667 26.5373 32.725 28.1998 32.725 30.2498C32.7083 32.2998 32.0917 33.9665 30.875 35.2498C29.6583 36.5331 27.8667 37.3498 25.5 37.6998V41.7998H22.625Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachMoney);
export default __webpack_public_path__ + "static/media/attach_money.006ffe9362cd30809a4ea0bb8f3eca57.svg";
export { ForwardRef as ReactComponent };